import { Model } from '@nozbe/watermelondb';
import { field, json, relation } from '@nozbe/watermelondb/decorators';

import { PrimeTopic } from '@src/types';
import { EntityType } from '@src/types/entityType';

const sanitizeContainedEntities = (containedEntities: any) => {
  return Array.isArray(containedEntities) ? containedEntities : [];
};

// @ts-ignore
export default class Page extends Model {
  static table = 'pages';
  static associations = {
    books: { type: 'belongs_to', key: 'book_id' },
  };

  @field('audio') audio?: string;
  @json('containedEntities', sanitizeContainedEntities) containedEntities: {
    entityId: string;
    entityType: EntityType;
    title: string;
  }[];
  @field('text') text?: string;
  @json('topic', (content) => content) topic?: PrimeTopic;
  @field('order') order: number;
  @field('is_downloaded') isDownloaded: boolean;

  @relation('books', 'book_id') book: any;
}
